import { collection, query, where, getDocs, writeBatch } from 'firebase/firestore';

// Tournaments and leagues hold their courts as rows in `reservations`, which is
// what puts them on the Schedule calendar and what stops anyone else booking
// that time. Those rows are created alongside the event (syncTournamentReservations
// in TournamentForm, the schedule builder in LeagueSchedule) and nothing removed
// them when the event was called off — so a cancelled tournament kept six courts
// blocked and still showed on the calendar as if it were happening.
//
// Returns how many holds were released, so the caller can say so rather than
// leaving the admin guessing whether anything happened.
export async function releaseCourtHolds(db, field, id) {
  if (!id) return 0;
  const snap = await getDocs(query(collection(db, 'reservations'), where(field, '==', id)));
  if (snap.empty) return 0;
  // Batches cap at 500 writes; 400 leaves room and matches the league clear.
  for (let i = 0; i < snap.docs.length; i += 400) {
    const batch = writeBatch(db);
    snap.docs.slice(i, i + 400).forEach(d => batch.delete(d.ref));
    await batch.commit();
  }
  return snap.docs.length;
}

export const releaseTournamentCourts = (db, tournamentId) =>
  releaseCourtHolds(db, 'tournamentId', tournamentId);

export const releaseLeagueCourts = (db, leagueId) =>
  releaseCourtHolds(db, 'leagueId', leagueId);
